import React from 'react';

import RequestReviewButton from './RequestReviewButton';
import PublishButton from './PublishButton';


const EventActionsButtons = (props) => (
	<>
		<RequestReviewButton {...props} />
		<PublishButton {...props} />
	</>
);

export default EventActionsButtons;